import * as formCaptcha from "@sharedJS/formCaptcha";
import * as rest from "@sharedJS/rest";
import * as formValidate from "@sharedJS/formValidate";
import pushDataLayer from "@ocm/services/dataLayer.js";

let $loginForm;
let $registrationForm;
let $rememberMeCheckbox;

// #myaccount-login-form: loginAndRegister.tag, reAuthPage.jsp
const loginFormId = "#myaccount-login-form";
const captchaLoginId = "captchaLogin";
const registrationFormId = "#js-registration-form";
const captchaRegistrationId = "captchaRegistration";

let captchaLoginElement;
let captchaRegistrationElement;
let errorClass;

const init = () => {
	$loginForm = $(loginFormId);
	$registrationForm = $(registrationFormId);

	const _hasLoginForm = $loginForm.length > 0;
	const _hasRegistrationForm = $registrationForm.length > 0;

	if (!_hasLoginForm && !_hasRegistrationForm) return;

	// Login
	if (_hasLoginForm) {
		$rememberMeCheckbox = $loginForm.find("#rememberMe");

		errorClass = "u-error-text";
		_loginFormEvents();

		formCaptcha.setCaptchaId(captchaLoginId, captchaLoginCallback);
		captchaLoginElement = formCaptcha.getCaptchaElement(captchaLoginId);
	}

	// Registrierung
	if (_hasRegistrationForm) {
		errorClass = "u-error-text";
		_registrationFormEvents();

		formCaptcha.setCaptchaId(captchaRegistrationId, captchaRegistrationCallback);
		captchaRegistrationElement = formCaptcha.getCaptchaElement(captchaRegistrationId);
	}

	_tracking();
	_togglePassword();
	_getActiveTab();
};

const _tracking = () => {
	const { pageName } = window.recommendationData.Recommendation.pageData;
	const trackingElements = document.querySelectorAll("[data-tracking-login]");
	trackingElements.forEach((trackingElement) => {
		trackingElement.addEventListener("click", (e) => {
			const eventAction = e.currentTarget.dataset.trackingLogin;
			pushDataLayer({
				event: "GAevent",
				event_category: "S_LoginLayer",
				event_action: eventAction,
				event_label: `S_${pageName}`,
			});
		});
	});
};

const _getActiveTab = () => {
	const isLogin = _getParam("login") !== null;
	const isRegistration = _getParam("registration") !== null;
	const loginTab = document.querySelector(".js-c-tabs__control--login");

	if (!isRegistration && loginTab && (isLogin || localStorage.getItem("loginTabActive"))) {
		loginTab.checked = true;
	}
};
const _getParam = (paramName) => {
	const queryString = decodeURIComponent(window.location.search.substring(1));
	const queryElements = queryString.split("&");
	for (let i = 0; i < queryElements.length; i++) {
		if (queryElements[i].split("=")[0] === paramName) {
			return queryElements[i].split("=")[1];
		}
	}
	return null;
};
const _loginFormEvents = () => {
	$loginForm.attr("novalidate", "novalidate");

	$loginForm.on("change", "input, select", (event) => {
		formValidate.validateElement(event.currentTarget, errorClass);
	});
	formValidate.removeErrorNoticeOnKeyUp($loginForm, { errorClass });

	_syncEmailInput($loginForm, $registrationForm);

	$loginForm.on("submit", function (event) {
		event.preventDefault();
		const isValid = formValidate.validateForm(this, { errorClass });
		if (!isValid) {
			return;
		}

		if (captchaLoginElement) {
			formCaptcha.execute(captchaLoginId, "LoginAndRegister");
		} else {
			_startLoginAction();
		}
	});

	$rememberMeCheckbox.on("change", (event) => {
		const $facebookLoginButton = $("a.js-login-facebook");

		if ($facebookLoginButton.length) {
			$facebookLoginButton.attr("isRememberMe", event.target.checked);
		}
	});
};

const captchaLoginCallback = () => {
	_startLoginAction();
};

const _startLoginAction = () => {
	const context = {
		form: $loginForm,
		callback: _startLoginAction,
		csrfErrorCallback: _showCsrfErrorMessage,
		setLoginTabActive: true,
	};
	rest.submitForm(context);
};

const _registrationFormEvents = () => {
	$registrationForm.attr("novalidate", "novalidate");

	$registrationForm.on("change", "input, select", (event) => {
		formValidate.validateElement(event.currentTarget, errorClass);
	});
	formValidate.removeErrorNoticeOnKeyUp($registrationForm, { errorClass });

	_syncEmailInput($registrationForm, $loginForm);

	$registrationForm.on("submit", function (event) {
		event.preventDefault();
		const isValid = formValidate.validateForm(this, { errorClass });
		if (!isValid) {
			return;
		}

		if (captchaRegistrationElement) {
			formCaptcha.execute(captchaRegistrationId, "Register");
		} else {
			_startRegistrationAction();
		}
	});
};

const captchaRegistrationCallback = () => {
	_startRegistrationAction();
};

const _startRegistrationAction = () => {
	const context = {
		form: $registrationForm,
		callback: _startRegistrationAction,
		csrfErrorCallback: _showCsrfErrorMessage,
		setLoginTabActive: true,
	};
	rest.submitForm(context);
};

const _showCsrfErrorMessage = () => {
	const $errorMessages = document.querySelectorAll(".js-login-registration-csrf-error");

	if ($errorMessages.length > 0) {
		$errorMessages.forEach((el) => {
			el.classList.remove("u-hide");
		});
	}
};

const _syncEmailInput = ($primary, $secondary) => {
	if ($secondary.length) {
		const $input = $secondary.find("input[type=email]");

		$primary.find("input[type=email]").on("change.email", (event) => {
			$input.val(event.target.value);
			formValidate.validateElement($input[0], errorClass);
		});
	}
};

const _togglePassword = () => {
	const $passwordToggle = $(".js-toggle-password");

	if ($passwordToggle.length) {
		$passwordToggle.on("click", function () {
			const $input = $(this).parent().find(".input--icon");
			const isMasked = $input.attr("type") === "password";
			$input.attr("type", isMasked ? "text" : "password");
			const $icon = $(this).find("use");
			const iconPath = $icon.attr("href");
			$icon.attr(
				"href",
				isMasked ? iconPath.replace("visibility", "visibility-off") : iconPath.replace("visibility-off", "visibility")
			);
		});
	}
};

export { init };
